import { render, staticRenderFns } from "./AccountsReceivable.vue?vue&type=template&id=00187640&"
import script from "./AccountsReceivable.vue?vue&type=script&lang=ts&"
export * from "./AccountsReceivable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports